import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    /* Estilo mantido at\xE9 finaliza\xE7\xE3o de new-layout, quando ser\xE1 removido */\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StyledH1 = styled.h1(_templateObject(), function (props) {
  return "\n        font: ".concat(props.theme.components.typography.fontH1, ";\n        color: ").concat(props.theme.components.typography.color, ";\n    ");
});
export var StyledH2 = styled.h2(_templateObject2(), function (props) {
  return "\n        font: ".concat(props.theme.components.typography.fontH2, ";\n        color: ").concat(props.theme.components.typography.color, ";\n    ");
});
export var StyledH3 = styled.h3(_templateObject3(), function (props) {
  return "\n        font: ".concat(props.theme.components.typography.fontH3, ";\n        color: ").concat(props.theme.components.typography.color, ";\n    ");
});
export var StyledH4 = styled.h4(_templateObject4(), function (props) {
  return "\n        font-family: \"Montserrat\";\n        font-size: 20px;\n        line-height: 32px;\n        font-weight: normal;\n        color: ".concat(props.theme.components.typography.color, ";\n    ");
});
export var LargeStyledText = function LargeStyledText(props) {
  return "\n    font-size: ".concat(props.theme.components.typography.largeFontSize, ";\n    line-height: ").concat(props.theme.components.typography.largeLineHeight, ";\n");
};
export var SmallStyledText = function SmallStyledText(props) {
  return "\n    font-size: ".concat(props.theme.components.typography.smallFontSize, ";\n    line-height: ").concat(props.theme.components.typography.smallLineHeight, ";\n");
};
export var StyledText = styled.p(_templateObject5(), function (props) {
  return "\n        font-family: ".concat(props.theme.components.typography.bodyFontFamily, ";\n        font-size: ").concat(props.theme.components.typography.fontSize, ";\n        line-height: ").concat(props.theme.components.typography.lineHeight, ";\n        font-weight: ").concat(props.theme.global.fontWeights["".concat(props.weight)], ";\n        color: ").concat(props.theme.components.typography.color, ";\n        margin: ").concat(props.theme.components.typography.textMargin, ";\n\n        ").concat(StyledText, " {\n            display: inline;\n        }\n\n        ").concat(props.large ? LargeStyledText(props) : '', "\n        ").concat(props.small ? SmallStyledText(props) : '', "\n\n        & > strong {\n            font-weight: ").concat(props.theme.global.fontWeights.visible, ";\n        }\n    ");
});